import { Nest } from 'ui/icons/action/Nest';
import { colors } from 'ui/theme/colors';

import {
  UpdatedLeftColCondition,
  EventConditionContainer,
  RowFlexSpaceBetween,
  UpdatedMidCol,
} from '../Styled';

export type EventConditionProps = {
  /** Children components */
  children: React.ReactNode;
  /** Identifier for the component */
  id: string;
  /** The string to be shown on left side of form fields */
  leftColText: string;
};
export const EventCondition = ({ children, id, leftColText }: EventConditionProps) => {
  return (
    <EventConditionContainer data-test={`${id}_EventCondition`}>
      <UpdatedLeftColCondition>
        <Nest color={colors.textSecondary} />
        <p>{leftColText}</p>
      </UpdatedLeftColCondition>
      <UpdatedMidCol>
        <RowFlexSpaceBetween>{children}</RowFlexSpaceBetween>
      </UpdatedMidCol>
    </EventConditionContainer>
  );
};
